export const zahtjev_SKDD = {
    templateId: 52.4,
    category: 6,
    templateTitle: "Zahtjev za dostavom podataka o vrijednosnicama",
    templateDescription: `<p>Vjerovnik ima pravo prije, tijekom ili nakon postupka ovrhe (ovrha na računima ili bilo koji drugi ovršni postupak protiv fizičke ili pravne osobe), od Središnjeg klirinškog depozitarnog društva ili druge osobe zatražiti podatak o tome da li ne neka osoba označena kao imatelj vrijednosnica, radi eventualnog pokretanja ovrhe na vrijednosnim papirima.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Kako bi naplatio svoju tražbinu, vjerovnik (ovrhovoditelj) ima pravo od Središnjeg klirinškog depozitarnog društva ili druge osobe zatražiti podatak o tome da li ne neka osoba ima ubilježene vrijednosnice na računima odnosno nematerijalizirane vrijednosne papire, dionice, obveznice, trezorske zapise, blagajničke zapise, komercijalne zapise, certifikate o depozitu i druge vrijednosne papire izdani u seriji, a spomenuto tijelo dužno je dati spomenute podatke.</p>
    <p>Na temelju dobivenog podatka i dokaza o nemogućnosti ovrhe na računima ovršenika uz dokaz FINA-e o nemogućnosti naplate, vjerovnik može pokrenuti ovrhu na pokretninama odnosno zatražiti provedbu ovrhe na drugom predmetu ili drugim sredstvom (nastavna ovrha).</p>
    <br>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Ovršni zakon.</p> `,
    sides: [
        {
          prefix: "",
          signature: "",
          inputs: [
              {
            type: "input",
            required: true,
            placeholder: "Naziv primatelja",
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto i poštanski broj",
          },
        ],
          suffix: "",
        }
      ],
    
      headline: "",
    
    title: 'Zahtjev za dostavom podataka o vrijednosnicama',
    noArticleNumbers: true,
    noArticleTitle: true,
 
    articles: [

      {
        title: "",
        mandatory: true,
        dummy: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              
              { type: "text", content: "Poštovani,\r\n\r\n",},
              { type: "text", newline:"true", content: "na temelju članka 18. st. 1. Ovršnog zakona zahtijevamo da nam dostavite podatak o tome ima li" },
              { type: 'input', value: '', required: true, placeholder: "Ime i prezime / Posl. subjekt" },
              { type: "text", content: "," },
              { type: 'text', content: 'iz',},
              { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
              { type: 'text', content: ',' },
              { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
              { type: "text", content: "," },
              { type: 'text', content: 'OIB:' },
              { type: "input",  required: true,},
              { help: "Ovdje upisujete podatke osobe protiv koje namjeravate pokrenuti ovršni postupak."},
              { type: "text", content: "u upisniku koji vodite ubilježene vrijednosnice na računima, odnosno nematerijalizirane vrijednosne papire, dionice, obveznice, trezorske zapise, blagajničke zapise, komercijalne zapise, certifikate o depozitu i druge vrijednosne papire izdane u seriji." }, 
            ],
          }
        ]
      },
      
        
               {
                 title: '',
                 mandatory: true,
                 dummy: true,
                 statements: [
                     {
                         type: 'text',
                         mandatory: true,
                         editable: true,
                         content: 'Ovim putem vas pozivamo da nam tražene podatke dostavite u zakonskom roku od 8 dana te vas u tom smislu upozoravamo na odredbu čl. 18. st. 7. Ovršnog zakona.',
                         value: '',
                     }],
             },
             {
              title: '',
              mandatory: true,
              dummy: true,
              statements: [
                  {
                      type: 'text',
                      mandatory: true,
                      editable: true,
                      content: 'Naime, protiv navedene osobe namjeravamo pokrenuti ovršni postupak, a dokaz o postojanju pravno interesa prilažemo uz ovaj Zahtjev.',
                      value: '',
                      help: 'Tijela od kojih se traže podaci, zahtijevaju postojanje pravnog interesa za traženje takvih podataka, stoga je potrebno poslati podatke na temelju kojima se može dokazati pravni interes - Izvod otvorenih stavaka, račun i sl..',
                  }],
          },
             {
                 title: '',
                 mandatory: true,
                 dummy: true,
                 statements: [
                     {
                         type: 'text',
                         mandatory: true,
                         editable: true,
                         content: 'Molimo za hitnost u postupanju.',
                         value: '',
                     }],
             },
             {
                 title: "",
                 mandatory: false,
                 dummy: true,
                 statements: [
                   {
                     type: "input",
                     mandatory: true,
                     parts: [
                       { type: "text", content: "Molimo Vas da nas obavijestite o iznosu dužne pristojbe na:" },
                       { type: 'input', value: '', required: true, },
                       { help: "Ovdje upisujete Vaše kontakt podatke. Naime, unaprijed nije moguće znati koliko nekretnina posjeduje osoba za koju se traže podaci pa time nije moguće niti unaprijed znati iznos pristojbi."},
                     ],
                   }
                 ]
               },
               {
                mandatory: true,
                static: true,
                type: 2, // date and place
                statements: [
                  {
                    type: "input",
                    mandatory: true,
                    parts: [
                      {
                        type: "text",
                        content: "U"
                      },
                      {
                        type: "input",
                        value: "",
                        placeholder: "Upišite mjesto.",
                        required: true,
                      },
                      {
                        type: "text",
                        content: ", dana"
                      },
                      {
                        type: "date",
                        value: new Date(),
                        required: true
                      },
                      {
                        type: "text",
                        content: "godine."
                      }
                    ]
                  },
                ]
              },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Prilog: \r\n1) Dokaz o postajanju pravnog interesa',
                        help: 'Nužno je priložiti dokaz o postojanju pravnog interesa - to mogu biti računi, izvodi iz poslovnih knjiga (izvodi otvorenih stavaka), presude, ugovori i sl..'
                     }
                    ]
                  },
                  {
                     static: true,
                     mandatory: false,
                     type: 4, 
                     statements: [
                       {
                         type: 'text',
                         mandatory: true,
                         editable: true,
                         content: 'Dostaviti:\r\n1) Primatelju zahtjeva \r\n2) Arhiva',
                         help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                       }
                     ]
                   },
            ],
 };
 
 
 
 
 
  
  
  
  
  
  
  
  
  


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/52.4_zahtjev_SKDD.ts